module.exports = __webpack_public_path__ + "static/media/2-solution-3.12e0e84d.mp3";